import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CategoryConfigurationService } from '@rocksoft/settings-sdk';
import { concatMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import {
  CategoryResolvedConfigurationApiActions,
  CategoryResolvedConfigurationResolverActions,
} from './category-resolved-configuration.actions';

@Injectable()
export class CategoryResolvedConfigurationEffects {
  private readonly actions = inject(Actions);
  private readonly categoryConfigurationService = inject(CategoryConfigurationService);

  /**
   * Effect to resolve category resolved configurations. Based on a CategoryId, it will call the CategoryConfigurationService
   * to get the resolved configuration for the Category (inheritance applied) and dispatch either a success or error action.
   * @returns An observable of the success or error action.
   */
  categoryResolvedConfigurationsResolverEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(CategoryResolvedConfigurationResolverActions.categoryResolvedConfigurationRequested),
      concatMap((action) => {
        return safeMap(
          this.categoryConfigurationService.getResolvedCategoryConfiguration({
            categoryId: action.categoryId,
          }),
          (configuration) => {
            return CategoryResolvedConfigurationApiActions.categoryResolvedConfigurationLoaded({ configuration });
          },
          (error) => {
            return CategoryResolvedConfigurationApiActions.categoryResolvedConfigurationLoadedError({
              error,
            });
          }
        );
      })
    );
  });
}
